'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _typography = require('./styles/typography');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = _react2.default.Component;

var Anchor = function (_Component) {
    _inherits(Anchor, _Component);

    function Anchor(props) {
        _classCallCheck(this, Anchor);

        var _this = _possibleConstructorReturn(this, (Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call(this, props));

        _this.state = {
            hover: false
        };

        _this.onClick = _this.onClick.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        return _this;
    }

    _createClass(Anchor, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            // Ensure onClick, onMouseEnter and onMouseLeave are pulled out from the ...rest params as they will be called from the instance methods

            var _props = this.props,
                to = _props.to,
                isActive = _props.isActive,
                onClick = _props.onClick,
                onMouseEnter = _props.onMouseEnter,
                onMouseLeave = _props.onMouseLeave,
                style = _props.style,
                hoverStyle = _props.hoverStyle,
                activeStyle = _props.activeStyle,
                primaryColor = _props.primaryColor,
                isDisabled = _props.isDisabled,
                rest = _objectWithoutProperties(_props, ['to', 'isActive', 'onClick', 'onMouseEnter', 'onMouseLeave', 'style', 'hoverStyle', 'activeStyle', 'primaryColor', 'isDisabled']);

            style = _extends({}, _typography.text, {
                color: primaryColor,
                outline: 'none',
                textDecoration: 'none'
            }, style);

            if (isActive) {
                style = _extends({}, style, activeStyle);
            }

            if (isDisabled) {
                style.pointerEvents = 'none';
            }

            if (this.state.hover) {
                style = _extends({}, style, hoverStyle);
            }

            if (to) {
                return _react2.default.createElement(
                    _reactRouter.Link,
                    _extends({ to: to, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, style: style }, rest),
                    this.props.children
                );
            }

            return _react2.default.createElement(
                'a',
                _extends({ ref: function ref(e) {
                        return _this2.element = e;
                    }, onClick: this.onClick, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, style: style }, rest),
                this.props.children
            );
        }
    }, {
        key: 'onClick',
        value: function onClick(event) {
            var href = this.props.href;


            if (!href) {
                event.preventDefault();
            }

            this.props.onClick(event);
        }
    }, {
        key: 'onMouseEnter',
        value: function onMouseEnter(event) {
            this.setState({
                hover: true
            });

            this.props.onMouseEnter(event);
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave(event) {
            this.setState({
                hover: false
            });

            this.props.onMouseLeave(event);
        }
    }]);

    return Anchor;
}(Component);

Anchor.defaultProps = {
    href: '',
    primaryColor: 'tomato',
    onClick: function onClick() {
        return null;
    },
    onMouseEnter: function onMouseEnter() {
        return null;
    },
    onMouseLeave: function onMouseLeave() {
        return null;
    }
};

exports.default = Anchor;
//# sourceMappingURL=Anchor.js.map